import React, { useEffect, useState } from 'react';
import ProductDetailPage from '../../pages/ProductDetailPage';
import ProductCard from '../ProductCard';
import { errorMessage, previewItem } from '../../api/catalogImportApi';
import { btnGhost, overlay } from './styles';

const VIEWS = [
  { key: 'page', text: 'Product page' },
  { key: 'card', text: 'In product listings' },
];

/**
 * Shows a draft on the real storefront components — the same ProductDetailPage and ProductCard
 * customers get — fed by the backend's own product conversion, so prices (GST-inclusive),
 * images and fields match what will actually go live. Nothing is saved.
 *
 * @param unsavedForm  the review form's current values (fromForm), so unsaved edits show too
 */
export default function ProductPreviewModal({ item, unsavedForm, onClose }) {
  const [product, setProduct] = useState(null);
  const [error, setError] = useState('');
  const [view, setView] = useState('page');

  useEffect(() => {
    let cancelled = false;
    previewItem(item.id, unsavedForm)
      .then((res) => { if (!cancelled) setProduct(res.data); })
      .catch((err) => { if (!cancelled) setError(errorMessage(err, 'Could not build the preview.')); });
    return () => { cancelled = true; };
  }, [item.id, unsavedForm]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div style={{ ...overlay, alignItems: 'stretch' }} role="dialog" aria-modal="true" aria-label="Storefront preview">
      <div style={{ background: '#fff', borderRadius: 12, width: 'min(1240px, 100%)', margin: '0 auto', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <header style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', padding: '12px 18px', borderBottom: '1.5px solid #E5E7EB', background: '#FFFBEB' }}>
          <strong style={{ fontSize: 14, color: '#92400E' }}>Preview — not live yet</strong>
          <span style={{ fontSize: 12, color: '#92400E' }}>
            As customers will see it once created and approved. Buttons are disabled.
          </span>
          <div role="tablist" aria-label="Preview view" style={{ display: 'flex', gap: 6, marginLeft: 'auto' }}>
            {VIEWS.map((v) => (
              <button key={v.key} role="tab" aria-selected={view === v.key} onClick={() => setView(v.key)}
                      style={{ ...btnGhost, padding: '6px 12px', ...(view === v.key ? { borderColor: '#F29213', color: '#B15400', background: '#FEF3E2' } : {}) }}>
                {v.text}
              </button>
            ))}
          </div>
          <button style={{ ...btnGhost, padding: '6px 12px' }} onClick={onClose} aria-label="Close preview">✕ Close</button>
        </header>

        <div style={{ flex: 1, overflowY: 'auto', background: '#F9FAFB' }}>
          {error ? (
            <p role="alert" style={{ color: '#B91C1C', padding: 24 }}>{error}</p>
          ) : !product ? (
            <p style={{ color: '#9CA3AF', padding: 24 }}>Building preview…</p>
          ) : view === 'page' ? (
            <div style={{ background: '#fff' }}>
              <ProductDetailPage previewProduct={product} />
            </div>
          ) : (
            <div style={{ padding: 32 }}>
              <p style={{ fontSize: 12, color: '#6B7280', margin: '0 0 12px' }}>How the product card looks in category and search listings.</p>
              {/* pointer-events off: the card's own Add to Cart / navigation must not fire on a draft. */}
              <div style={{ width: 280, pointerEvents: 'none' }}>
                <ProductCard product={product} userRole="CUSTOMER" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
